import React from 'react';
import { motion } from 'framer-motion';
import { FramedPortrait } from '../components/ui/FramedPortrait';
import { TopicNavCards } from '../components/sections/TopicNavCards';
const introPoints: string[] = ['Director-Level Executive with 9+ years of progressive leadership at Ameren ($9.5B+ revenue Fortune 500 utility serving 3.3M+ customers).', 'Leader in energy transition strategy, corporate innovation, clean-tech commercialization, and utility growth initiatives.', 'Direct experience in commercializing 400+ MW of solar capacity, scaling 45+ clean-tech innovation pilot projects, and structuring multi-million dollar venture partnerships.'];
export function AboutPage() {
  return <div data-id="element-192" data-mp="3de0raxm5d3ko">
      <section className="bg-ice py-16 lg:py-24" data-id="element-193" data-mp="3deakeu2hnqul">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-3xl px-6 text-center lg:px-10" data-id="element-194" data-mp="3dflnsss0uwl6">
          <FramedPortrait src="https://cdn.magicpatterns.com/uploads/sLAp8v5cFWyNA9xMpxs6oJ/bvcvbnm-Picsart-AiImageEnhancer.webp" alt="Portrait of Elijah Gerson" data-id="element-195" data-mp="2ev64fdi80gkv" />
          <h1 className="mt-8 font-heading text-3xl font-semibold text-navy sm:text-4xl" data-id="element-196" data-mp="25wkqxwrlvrqy">
            ELIJAH (&quot;ELI&quot;) GERSON
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm font-semibold uppercase tracking-[0.08em] text-brandgreen sm:text-base" data-id="element-197" data-mp="2awgu5tshbf5g">
            Director-Level Executive | Energy Transition Strategy, Corporate Innovation &amp; Board Governance
          </p>
        </motion.div>
      </section>

      <section className="bg-white py-16 lg:py-20" data-id="element-198" data-mp="2osau3nb9yu6f">
        <div className="mx-auto max-w-3xl px-6 lg:px-10" data-id="element-199" data-mp="2tsoq26zlqdo3">
          <ul className="space-y-5" data-id="element-200" data-mp="2tr5c4n1f4eph">
            {introPoints.map(point => <li key={point} className="flex gap-3 rounded-xl border border-slate-200 bg-white p-6" data-id="element-201" data-mp="3hhrjec3lluyf">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brandgreen" aria-hidden="true" data-id="element-202" data-mp="3mbvqqwgs0501" />
                <p className="text-base leading-relaxed text-charcoal" data-id="element-203" data-mp="3w3f4q0ljf5iv">{point}</p>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-white pb-20 lg:pb-28" data-id="element-204" data-mp="3m6k3h9xvqr0w">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-205" data-mp="3h8ipv4j83jwt">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brandgreen" data-id="element-206" data-mp="3h7z57g26uhf3">
            Explore the Full Profile
          </p>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-navy sm:text-3xl" data-id="element-207" data-mp="38g70llzui2if">
            Nine sections, each with a single purpose
          </h2>
          <div className="mt-10" data-id="element-208" data-mp="33hlvb85qksn4">
            <TopicNavCards data-id="element-209" data-mp="2yi0zv7prz2f5" />
          </div>
        </div>
      </section>
    </div>;
}